// src/api/inventory.ts
import { apiRequest } from "../utils/apiClient"; // Adjust the path as needed

export const addInventory = async (items: any[]) => {
  const response = await apiRequest(
    "/api/transfers/addInventoryTransfer",
    "POST",
    {
      items,
    },
  );
  if (response.status !== 200) {
    throw new Error(response.message);
  }
  return response.data;
};

export const updateTransferPicked = async (
  transferId: string,
  picked: boolean,
  qty_packed: number,
  qty_unpacked: number,
) => {
  const response = await apiRequest("/api/transfers/picked", "POST", {
    transferId,
    picked,
    qty_packed,
    qty_unpacked,
  });

  if (response.status !== 200) {
    throw new Error(response.message);
  }

  return response.data;
};
